import { firePanel, electricPanel, controlPanel, dewtectSensor } from '~/config/utilityBoxes'
import LAYER_KEYS, { LayerKeys } from '~/config/layerKeys'
import { MenuDropDownButton } from '../components/MenuDropDownButton'
import { MenuItem } from '~/ui/Menu'
import { Icon } from '~/ui/Icon'
import { useAppDispatch } from '~/store/hooks'
import { setCurrentLayer } from '~/store/layers'
import { setActiveTool } from '~/store/tools'
import { showPanel } from '~/store/panel'
import { SetActiveToolPayload } from '~/store/tools/reducer'

export default function ObstructionsAndPanelsMenu() {
  const dispatch = useAppDispatch()
  const action = (layerKey: LayerKeys, toolPayload: SetActiveToolPayload) => () => {
    dispatch(setCurrentLayer({ layerKey }))
    dispatch(setActiveTool(toolPayload))
  }

  return (
    <MenuDropDownButton label="Obstructions & Panels" icon="obstruction">
      <MenuItem onAction={action(LAYER_KEYS.OBSTRUCTIONS, { tool: 'OBSTRUCTION_BOX_TOOL' })} variant="square">
        <Icon name="obstruction" size="14" />
        Basic Obstruction
      </MenuItem>
      <MenuItem
        onAction={action(LAYER_KEYS.UTILITY_BOXES, { tool: 'UTILITY_BOX_TOOL', props: firePanel })}
        variant="square"
      >
        <Icon name="panelFire" size="14" />
        Fire Panel
      </MenuItem>
      <MenuItem
        onAction={action(LAYER_KEYS.UTILITY_BOXES, { tool: 'UTILITY_BOX_TOOL', props: electricPanel })}
        variant="square"
      >
        <Icon name="panelElectric" size="14" />
        Electric Panel
      </MenuItem>
      <MenuItem
        onAction={action(LAYER_KEYS.UTILITY_BOXES, { tool: 'UTILITY_BOX_TOOL', props: controlPanel })}
        variant="square"
      >
        <Icon name="panelControl" size="14" />
        Controller
      </MenuItem>
      <MenuItem
        onAction={action(LAYER_KEYS.UTILITY_BOXES, { tool: 'UTILITY_BOX_TOOL', props: dewtectSensor })}
        variant="square"
      >
        <Icon name="sensor" size="14" />
        Dewtect Sensor
      </MenuItem>
      <MenuItem onAction={() => dispatch(showPanel({ type: 'DETAILED_OBSTRUCTION_PANEL' }))} variant="square">
        <Icon name="window" size="14" />
        Obstruction Library
      </MenuItem>
    </MenuDropDownButton>
  )
}
